<template>
  <div class="columns is-multiline is-centered">
    <div class="column is-half">
      <b-input rounded icon="search" type="search" v-model="filterText" placeholder="Filter by carrier name"/>
    </div>
    <div class="column is-full">
      <b-table :data="filteredList"
             :loading="isFetching"
             striped
             hoverable>

      <template slot="empty" v-show="!isFetching">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p >There are no carriers pending approval.</p>
          </div>
        </section>
      </template>

      <template slot-scope="props">
        <b-table-column label="" width="350">
          <div class="buttons is-centered are-small">
            <button class="button is-success"
                    :class="{ 'is-loading': listOfLoadings.includes(props.row.accountKey) }"
                    @click="_takeAction('approveCarrier', props.row.accountKey)">
              Approve
            </button>

            <button class="button"
                    :class="{ 'is-loading': listOfLoadings.includes(props.row.accountKey) }"
                    @click="_takeAction('rejectCarrier', props.row.accountKey)">
              Reject
            </button>
          </div>
        </b-table-column>

        <!--
        <b-table-column label="Profile">
          <router-link :to="{ name: 'carrier-profile', params: {accountKey: props.row.accountKey }}">
            View Profile
          </router-link>
        </b-table-column>
        -->

        <b-table-column label="Carrier">
          <router-link :to="{ name: 'carrier-profile', params: {accountKey: props.row.accountKey }}">
          {{ props.row.accountFirstName }} {{ props.row.accountLastName }}
          </router-link>
        </b-table-column>

        <b-table-column v-for="doc in documentList" :key="doc.fieldName" :label="doc.displayName">
          <view-file-button v-if="props.row.carrier[doc.dbFieldName]"
                            :s3-key="`account/${props.row.accountKey}/carrier_document/${doc.fileName}${doc.fileExtension}`" />
          <font-awesome-icon v-else
                             icon="minus" />
        </b-table-column>

        <b-table-column>

          <button class="button is-small is-info"
                  :disabled="props.row.factoringProviderApprovalStatus.toLocaleLowerCase() === 'preapproved'"
                  :title:="props.row.factoringProviderApprovalStatus.toLocaleLowerCase() === 'preapproved' ? 'Carrier is already preapproved' : ''"
                  :class="{ 'is-loading': listOfLoadings.includes(props.row.accountKey) }"
                  @click="_takeAction('preApproveCarrier', props.row.accountKey)">
            Preapprove
          </button>
        </b-table-column>

        <!--
        <b-table-column label="Articles of Incorporation">
            <view-file-button v-if="props.row.carrier.carrierHasUploadedArticlesOfIncorporation"
                              :s3-key="`account/${props.row.accountKey}/carrier_document/articles-of-incorporation`" />
            <font-awesome-icon v-else
                               icon="minus" />
        </b-table-column>

        <b-table-column label="Voided Check">
          <view-file-button v-if="props.row.carrier.carrierHasUploadedVoidedCheck"
                            :s3-key="`account/${props.row.accountKey}/carrier_document/voided-check`" />
          <font-awesome-icon v-else
                             icon="minus" />
        </b-table-column>

        <b-table-column label="Drivers License">
          <view-file-button v-if="props.row.carrier.carrierHasUploadedDriversLicense"
                            :s3-key="`account/${props.row.accountKey}/carrier_document/driver-license`" />
          <font-awesome-icon v-else
                             icon="minus" />
        </b-table-column>
        -->
      </template>
    </b-table>
    </div>
  </div>
</template>

<script>
// TODO: this is 90% similar to FactoringApprovalsShipperTable.vue and should be made more generic
import { mapGetters, mapActions } from 'vuex'

import ViewFileButton from '@/components/ViewDocumentIcon'
import CarrierFileUploads from '@/lookup-data/carrier-file-uploads'

export default {
  name: 'FactoringApprovalsCarrierTable',

  data() {
    return {
      documentList: CarrierFileUploads,
      listOfLoadings: [],
      isFetching: false,
      filterText: ''
    }
  },

  components: {
    ViewFileButton
  },

  computed: {
    ...mapGetters('factoring', { carriers: 'pendingApprovalCarriers' }),
    filteredList() {
      return this.carriers.filter(
        (carrier) =>
          carrier.accountFirstName.toLowerCase().includes(this.filterText) ||
          carrier.accountLastName.toLowerCase().includes(this.filterText)
      )
    }
  },

  async created() {
    if (this.carriers.length === 0) {
      this.isFetching = true
      try {
        await this.fetchPendingApprovals()
      } catch (error) {
        console.error(`Error fetching carrier approval list`, error)
      } finally {
        this.isFetching = false
      }
    }
  },

  methods: {
    ...mapActions('factoring', ['fetchPendingApprovals', 'rejectCarrier', 'approveCarrier', 'preApproveCarrier']),
    async _takeAction(actionName, key) {
      this.listOfLoadings.push(key)
      try {
        await this[actionName](key)
      } catch (error) {
        console.error(`Error acting on factoring`, error)
      } finally {
        const targetIndex = this.listOfLoadings.indexOf(key)
        this.listOfLoadings.splice(targetIndex, 1)
        this.fetchPendingApprovals()
      }
    }
  }
}
</script>

<style scoped>
</style>
